import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@mui/styles'
import { ButtonSquare, DEBOUNCE_TIMES, SplitButton } from '@/modules/base/components/buttons/index'

import lang from '@/lang'
import { expenseStates, revenueStates, transactionTypes } from '@/modules/base/util/constants'
import DropDownItem from '@/modules/base/components/buttons/split-button/drop-down-item/drop-down-item'
import IconEuro from '@assets/images/icons/euro.svg'
import IconLink from '@assets/images/icons/link.svg'
import IconBankTransfer from '@assets/images/bank_transfer.svg'
import IconEdit from '@assets/images/icons/pencil.svg'
import moment from 'moment'
import AssignmentDrawer from '@/modules/base/components/assignment-drawer/assignment-drawer'
import BankTransferDrawer from '@/modules/base/components/bank-transfer-drawer/bank-transfer-drawer'
import PaymentDrawer from '@/modules/base/components/payment-drawer-v2/payment-drawer'
import { closeEditDrawer, setEconomicAssetIdNull } from '@/redux/ducks/economicAsset/list'
import { useNavigate } from 'react-router'

const { IN_PROGRESS, PAID } = expenseStates
const { PAID: revenueStatePaid } = revenueStates

const notPayableStatesRevenue = [
  revenueStatePaid,
]

const notPayableStatesExpense = [
  IN_PROGRESS,
  PAID,
]

const { TRANSACTION_TYPE_REVENUE, TRANSACTION_TYPE_EXPENSE } = transactionTypes

const ExpenseAndRevenueDrawerActionButtons = (props) => {
  const { expense, revenue, isEconomicAsset, onClose } = props
  const classes = useStyles(props)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const data = revenue ? { ...revenue, type: TRANSACTION_TYPE_REVENUE } : { ...expense, type: TRANSACTION_TYPE_EXPENSE }

  const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false)
  const [openAssignmentDrawer, setOpenAssignmentDrawer] = useState(false)
  const [openBankTransferDrawer, setOpenBankTransferDrawer] = useState(false)

  const onEditButtonClick = () => {
    expense ? navigate(`/expense/edit/${expense.id}`) : navigate(`/revenue/edit/${revenue.id}`)
    if (isEconomicAsset) {
      dispatch(closeEditDrawer())
      dispatch(setEconomicAssetIdNull())
    }
  }

  const showPaymentSplitButton = data.type === TRANSACTION_TYPE_REVENUE ? !notPayableStatesRevenue.includes(data.state) : !notPayableStatesExpense.includes(data.state)

  const paymentDropDown = [
    { label: data.type === TRANSACTION_TYPE_REVENUE ? lang.banking.list.editRevenue : lang.banking.list.editExpense, icon: IconEdit, onClick: onEditButtonClick },
    { label: lang.payments.cell.paymentCellLabel, icon: IconEuro, onClick: () => setOpenPaymentDrawer(true) },
    { label: lang.payments.cell.assignmentCellLabel, icon: IconLink, onClick: () => setOpenAssignmentDrawer(true) },
  ]

  data.type === TRANSACTION_TYPE_EXPENSE && paymentDropDown.push({ label: lang.payments.cell.bankTransferCellLabel, icon: IconBankTransfer, onClick: () => setOpenBankTransferDrawer(true) })

  const renderEditButton = () => {
    return showPaymentSplitButton
      ? (<SplitButton
        label={data.type === TRANSACTION_TYPE_REVENUE ? lang.banking.list.editRevenue : lang.banking.list.editExpense}
        onClick={onEditButtonClick}
        debounceTime={DEBOUNCE_TIMES.MINIMAL}
        autoClosePopper
      >
        {paymentDropDown.map((item, i) => (
          <DropDownItem icon={item.icon} onClick={item.onClick} label={item.label} key={i} />
        ))}
      </SplitButton>)
      : (<ButtonSquare
        label={data.type === TRANSACTION_TYPE_REVENUE ? lang.banking.list.editRevenue : lang.banking.list.editExpense}
        onClick={onEditButtonClick}
        customClass={classes.buttonSquare}
      />)
  }

  return (
    <div className={classes.container}>
      <div className={classes.buttons}>
        {renderEditButton()}
        {openPaymentDrawer
        && <PaymentDrawer
          open={openPaymentDrawer}
          isOverDue={moment(data.dueDate).isBefore(new Date(), 'day')}
          onClose={() => setOpenPaymentDrawer(false)}
          onConfirm={onClose}
          transaction={data}
          dunnings={[]}
          withoutPdf
        />}
        {openBankTransferDrawer
        && <BankTransferDrawer
          open={openBankTransferDrawer}
          onClose={() => setOpenBankTransferDrawer(false)}
          onConfirm={onClose}
          transaction={data}
          withoutPdf
        />}
        {openAssignmentDrawer
        && <AssignmentDrawer
          open={openAssignmentDrawer}
          isOverDue={moment(data.dueDate).isBefore(new Date(), 'day')}
          onClose={() => setOpenAssignmentDrawer(false)}
          onConfirm={onClose}
          transaction={data}
        />}
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    padding: '10px 0px 10px 0px',
    backgroundColor: theme.backgroundColor,
    borderTop: theme.borderColor,
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    marginRight: 30,
  },
  buttonSquare: {
    minWidth: 235,
    maxWidth: 235,
  },
}))

export default ExpenseAndRevenueDrawerActionButtons
